import { NgModule } from '@angular/core';

import { CommonModule } from "@angular/common";
import { CellBlockMarginComponent } from "./cell-block-margin.component";
import { FormBuilderModule } from "libraries/module/formbuilder/form-builder.module";
import { TdNumberValueEditableModule } from "libraries/component/table/td-number-value-editable/td-number-value-editable.module";
import { TdPercentModule } from "../td-percent/td-percent.module";

@NgModule({
    imports: [
        CommonModule,
        TdPercentModule,
        FormBuilderModule,
        TdNumberValueEditableModule,
    ],
    exports: [
        CellBlockMarginComponent,
    ],
    declarations: [
        CellBlockMarginComponent
    ],
    providers: [],
})
export class CellBlockMarginModule {
}
